module.exports = __webpack_public_path__ + "static/img/Charlie-Cameron.361f485.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie-Cameron.jpg
// module id = 5RfW
// module chunks = 0